import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import history from '../../utils/customHistory';
import SkillDropDown from './skillFilter';
import RegionDropDown from './regionFilter';
import RoleDropDown from './roleFilter';
import { JOB_REGION } from '../../utils/constant';
import BusinessSelectDropdown from './businessFilter';
import SearchFilter from './searchFilter';

const JobFilter = ({applyFilter}) => {
    const [filter, setFilter] = useState({})

    const {skills, candidatesRole} = useSelector((state) => {
        return {
            skills: state?.skills?.skills || [],
            candidatesRole: state.candidates?.candidatesRole
        }
    });

    useEffect(() => {
        let initialFilter = {};
        const url = new URLSearchParams(history.location.search)
        const params = {};
        url.forEach((value, key) => {
            params[key] = value;
        })

        if (!!params.skills) {
            const allSearchedSkills = params?.skills?.split(",");
            initialFilter = {...initialFilter, skills: skills.filter(({slug}) => allSearchedSkills.includes(slug))}
        }
        if (!!params.region) {
            initialFilter = {
                ...initialFilter,
                region: JOB_REGION.find(({value}) => value === params?.region)
            }
        }

        if (!!params.role) {
            initialFilter = {...initialFilter, role: candidatesRole.find(({slug}) => slug === params.role)}
        }

        if (!!params?.businessId?.trim()) {
            initialFilter = {
                ...initialFilter,
                businessId: params?.businessId?.trim(),
            };
        }
        setFilter(initialFilter)
    }, [])

    const handlerFilterChange = (name, value) => {
        let updatedFilter = {...filter};

        updatedFilter = {...filter, [name]: value};
        setFilter(updatedFilter)

        const queryParamsObject = {}
        Object.keys(updatedFilter).forEach((key) => {
            switch (key) {
                case "skills": {
                    if (updatedFilter[key]?.length) {
                        queryParamsObject[key] = updatedFilter[key].map(({slug}) => slug).join(",");
                    }
                    break;
                }
                case "region": {
                    if (!!updatedFilter[key]) {
                        queryParamsObject[key] = updatedFilter[key]?.value;
                    }
                    break
                }
                case "role": {
                    if (!!updatedFilter[key]) {
                        queryParamsObject[key] = updatedFilter[key]?.slug;
                    }
                    break
                }
                case 'businessId': {
                    if (!!updatedFilter[key]) {
                        queryParamsObject[key] = updatedFilter[key];
                    }
                }
                case 'title': {
                    if (!!updatedFilter[key]) {
                        queryParamsObject[key] = updatedFilter[key];
                    }
                }
            }
        })
        applyFilter(queryParamsObject)
    }

    return (
        <div>
            <Grid container mt={3} mb={3} spacing={2}>
                <Grid item xs={12} md={3}>
                    <RegionDropDown
                        name="search"
                        selectedData={filter["region"]}
                        handleChange={(value) => handlerFilterChange("region", value)}
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <SkillDropDown
                        selectedData={filter["skills"]}
                        handleChange={(value) => handlerFilterChange("skills", value)}
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <RoleDropDown
                        selectedData={filter["role"]}
                        handleChange={(value) => handlerFilterChange("role", value)}
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <BusinessSelectDropdown  selectedData={filter["businessId"]} handleChange={(value) => handlerFilterChange("businessId", value)} />
                </Grid>
                <Grid item xs={12} md={3}>
                    <SearchFilter
                      name='title'
                      title={'Designation'}
                      placeholder={'Enter designation'}
                      selectedData={filter['title']}
                      handleChange={(event) => handlerFilterChange('title', event?.target?.value)}
                    />
                </Grid>
            </Grid>
        </div>
    )
}

export default JobFilter;

